module.exports = __webpack_public_path__ + "img/cheese-burger.d3ee653b.png";